// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper[data-v-f6176956] {
  display: flex;
  gap: 30px;
}
.bordered[data-v-f6176956] {
  border-top-right-radius: 0.3rem !important;
  border-bottom-right-radius: 0.3rem !important;
  border-top-left-radius: 0.3rem !important;
  border-bottom-left-radius: 0.3rem !important;
  border-right-width: 0.1rem !important;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
